import SpriteIcon from "./SpriteIcon";
import {SpriteIconsType} from "./interfaces";

export default SpriteIcon;
export {SpriteIconsType};
